import React, { PureComponent } from 'react';
import { toast } from 'react-toastify';
import _ from 'lodash';
import IconToast from '../../../components/NewToast';
import { validatePassword, validatePasswordConfirm } from '../../../utils/validators';
import AppContentContainer from '../../../components/AppContentContainer/AppContentContainer';
import PasswordRulesInfoTooltip from '../../../components/PasswordRulesInfoTooltip/PasswordRulesInfoTooltip';
import LoadingBackdrop from '../../../components/LoadingBackdrop/LoadingBackdrop';
import { Button, TextField, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import ForgotPasswordStyles from '../ForgotPasswordStyles';

class ResetPasswordView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      confPassword: '',
      newPassword: '',
      id: '',
      err: {},
      loginStatus: false
    };
    this.submitForm = this.submitForm.bind(this);
    this.backToLogin = this.backToLogin.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (this.props.match.params.Id) {
      var id = this.props.location.pathname.replace('/reset_password/', '');
      this.setState({ id: id });
    }
  }

  componentDidMount() {
    //to display the page language as per the browser language
    var user = this.props.userDetails;
    if (_.isEmpty(user)) {
      var userLang = navigator.language || navigator.userLanguage;
      const language = userLang === 'zh-HK' ? 'zh-Hant-HK' : userLang === 'zh-CN' ? 'zh' : 'en';
      this.props.selectedLocale(language);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { intl } = this.props;
    if (nextProps.resetPasswordPhase === true) {
      this.setState({
        newPassword: '',
        confPassword: ''
      });
      this.setState({ loginStatus: true });
      toast.info(IconToast('info', intl.formatMessage({ id: nextProps.message })), { className: 'new-toast' });
    }
    if (nextProps.resetPasswordPhase === false) {
      toast.info(IconToast('info', intl.formatMessage({ id: nextProps.message })), { className: 'new-toast' });
    }
  }

  handleChange(e) {
    if (this.state.err.newPassword !== '') {
      delete this.state.err.newPassword;
    }
    if (this.state.err.confPassword !== '') {
      delete this.state.err.confPassword;
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  //sending the new password to update in users record
  submitForm() {
    const err = {};
    if (this.state.newPassword === '' || this.state.confPassword === '') {
      err.confPassword = 'Enter complete details';
    }

    const passwordValidationResult = validatePassword(this.state.newPassword);
    if (passwordValidationResult) {
      err.newPassword = passwordValidationResult;
    }
    const passwordConfirmValidationResult = validatePasswordConfirm(this.state.confPassword, this.state.newPassword);
    if (passwordConfirmValidationResult) {
      err.confPassword = passwordConfirmValidationResult;
    }

    this.setState({ err });
    if (!Object.keys(err).length) {
      var formData = {};
      formData.token = this.state.id;
      formData.password = this.state.newPassword;
      this.props.resetPassword(formData);
    }
  }
  backToLogin() {
    const { history } = this.props;
    history.push({
      pathname: '/login'
    });
  }

  render() {
    const { intl, classes } = this.props;
    const { loginStatus, err } = this.state;
    return (
      <AppContentContainer>
        {this.props.resetPasswordPhase === 'loading' && <LoadingBackdrop open={true} />}
        <div className={classes.resetWrapper}>
          <div className={classes.form}>
            <img
              alt=""
              src="img/reset-password.svg"
              style={{ display: 'block', margin: '0 auto 16px', width: 120, maxWidth: '45%' }}
            />
            <Typography className={classes.forgotHint}>
              {intl.formatMessage({ id: 'reset-password-hint' })}
            </Typography>

            <PasswordRulesInfoTooltip password={this.state.newPassword}>
              <TextField
                type="password"
                variant="outlined"
                margin="normal"
                fullWidth
                autoComplete="new-password"
                name="newPassword"
                value={this.state.newPassword}
                onChange={this.handleChange.bind(this)}
                className={classes.logindetails}
                label={intl.formatMessage({ id: 'New Password*' })}
                error={!!err.newPassword}
                helperText={err.newPassword ? intl.formatMessage({ id: err.newPassword }) : ''}
                slotProps={{
                  input: {
                    classes: {
                      root: classes.inputBase,
                      input: classes.input
                    }
                  },
                  inputLabel: { className: classes.inputLabel }
                }}
              />
            </PasswordRulesInfoTooltip>

            <PasswordRulesInfoTooltip password={this.state.confPassword}>
              <TextField
                type="password"
                variant="outlined"
                margin="normal"
                fullWidth
                autoComplete="new-password"
                name="confPassword"
                value={this.state.confPassword}
                onChange={this.handleChange.bind(this)}
                className={classes.logindetails}
                label={`${intl.formatMessage({ id: 'Confirm Password' })}*`}
                error={!!err.confPassword}
                helperText={err.confPassword ? intl.formatMessage({ id: err.confPassword }) : ''}
                slotProps={{
                  input: {
                    classes: {
                      root: classes.inputBase,
                      input: classes.input
                    }
                  },
                  inputLabel: { className: classes.inputLabel }
                }}
              />
            </PasswordRulesInfoTooltip>

            <div className={classes.forgotButtonWrap}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                className={classes.submit}
                onClick={this.submitForm}
                disabled={loginStatus}
              >
                {intl.formatMessage({ id: 'Submit' })}
              </Button>
            </div>

            {loginStatus && (
              <Button color="primary" fullWidth className={classes.backToLoginBtn} onClick={this.backToLogin}>
                {intl.formatMessage({ id: 'Back to Login' })}
              </Button>
            )}
          </div>
        </div>
      </AppContentContainer>
    );
  }
}

export default withStyles(ResetPasswordView, ForgotPasswordStyles);
